import { inject, Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { catchError, Observable, of } from 'rxjs';
import { EventCategoriesService } from '../services/event-categories.service';

@Injectable({
  providedIn: 'root'
})
export class EventCategoryResolver implements Resolve<boolean> {
  private eventCategoryService= inject(EventCategoriesService);
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.eventCategoryService.getAllEventCategories({}).pipe(
      catchError(error => {
        return [];
      })
    )
  }

}
